import * as d3 from 'd3'
export default {

  methods: {
    draw_BarChart(selection, group, chtData) {

      // Draw Bar Chart 
      this.timeline.xItems.forEach((d,i)=> {

        let stackY = this.chart.height

        this.chart.styles.filter(f=> f.type == 'BAR').forEach((st,s)=> {
          
          let value = chtData.find(f=> f[this.timeline.refCode] == d.name)[st.code]
          if(value == undefined || value < 0) value = 0

          stackY = stackY - this.primary.axis(value)

          selection
          .append('rect')
          .attr('class', `BAR_${group.id}_${s}_${this.localId}`)
          .attr('x', d.mx - (st.size/2)).attr('y', stackY)
          .attr('width', st.size).attr('height', this.primary.axis(value))
          .attr('fill', st.bColor).attr('opacity', st.opacity)

          if(st.vSize > 0 && value > 0) {
            selection
            .append('text')
            .attr('class', `VALUE_${group.id}_${s}_${this.localId}`)
            .attr('x', d.mx).attr('y', stackY + (this.primary.axis(value)/2) + st.vSize*0.36)
            .attr('font-size', st.vSize).attr('fill',  st.vColor)
            .attr('text-anchor', 'middle').attr('opacity', 1)
            .text(value+(st.unit ? st.unit : ''))
            .call(this.call_LINK, chtData.find(f => f[this.timeline.refCode] == d.name), {
              type: 'CHART',
              d: {...d},
              st: {...st},
            })
          }

        })

        // Period Total
        let stack = this.chart.stackTotal
        if(stack.visible == 'Y') {
          selection
          .append('text')
          .attr('class', `TOT_${group.id}_${this.localId}`)
          .attr('x', d.mx).attr('y', stackY - 4)
          .attr('font-size', stack.tSize).attr('fill', stack.tColor).attr('text-anchor', 'middle').attr('opacity', 1)
          .text(d.sum)
          .call(this.call_LINK, chtData.find(f => f[this.timeline.refCode] == d.name), {
            type: 'CHART',
            d: {...d},
            st: {filter: stack.filter}
          })
        }

      })

      this.chart.styles.forEach((st,s)=> {
        d3.selectAll(`.VALUE_${group.id}_${s}_${this.localId}`).moveToFront()
      })

    },
    



    draw_LineChart(selection, chtData) {

      this.chart.styles.filter(f=> f.type == 'LINE').forEach((st,s)=> {

        let lineFunc = d3.line()
        .x((d,i) => this.timeline.xItems[i].mx)
        .y(d => this.secondary.axis(d[st.code]))

        selection
        .append('path')
        .attr('d', lineFunc(chtData))
        .attr('stroke', st.bColor).attr('stroke-width', st.size)
        .style("stroke-dasharray", (st.dash, st.dash))
        .attr('fill', 'none').attr('opacity', st.opacity)

        chtData.forEach((d,i)=> {
          
          let x_ = this.timeline.xItems[i].mx
          if(st.node > 0) { // Node
            selection
            .append('circle')
            .attr('cx', x_).attr('cy', this.secondary.axis(d[st.code])).attr('r', st.node)
            .attr('fill', st.bColor).attr('opacity', st.opacity)
          }
          
          if(st.vSize > 0) { // Value
            selection
            .append('text')
            .attr('x', x_).attr('y', this.secondary.axis(d[st.code]) -4)
            .attr('font-size', st.vSize).attr('fill',  st.vColor)
            .attr('text-anchor', 'middle').attr('opacity', 1)
            .text(d[st.code])
            .call(this.call_LINK, d, {
              type: 'CHART',
              st: {...st},
            })
          }
        })

      })

    },
    
  }
}